import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./DocumentRegister.css";

const CommonForm = ({
  currentPattern,
  setCurrentPattern,
  onSubmit,
  onGoBack,
  onIssue,
  autoNumber,
  attributePatternText,
  onFormDataChange,
  loading,
  resetToken = 0,
  isHakkouDisabled,
}) => {
  // ReduxとURLがない場合
  const { deptId, folderId } = useParams();

  // 文字の幅カウントーーーーーーーーーーーーーーーーーーーーーーーーー
  const getCharacterWidth = (text) => {
    if (!text) return 0;
    let width = 0;
    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const code = char.charCodeAt(0);
      // 全角文字かどうかを判定する関数
      if (
        (code >= 0x3040 && code <= 0x309f) || // Hiragana
        (code >= 0x30a0 && code <= 0x30ff) || // Katakana
        (code >= 0x4e00 && code <= 0x9fff) || // CJK Ideographs
        (code >= 0xff00 && code <= 0xffef) || // Full-width ASCII
        (code >= 0x3000 && code <= 0x303f) // Full-width symbols
      ) {
        width += 2; // Full-width characters count as 2
      } else {
        width += 1; // Half-width characters count as 1
      }
    }
    return width;
  };
  // 文字の幅カウントーーーーーーーーーーーーーーーーーーーーーーーーー

  // デモように
  const menuData = [
    {
      department_id: "D001",
      department_name: "計装・システム制御",
      folder: [
        { folder_id: "F001", folder_name: "E版図面" },
        { folder_id: "F002", folder_name: "T版図面" },
        { folder_id: "F003", folder_name: "D版図面" },
        { folder_id: "F004", folder_name: "C版図面" },
        { folder_id: "F005", folder_name: "B版図面" },
      ],
    },
    {
      department_id: "D002",
      department_name: "システム装置",
      folder: [
        { folder_id: "F006", folder_name: "EM版図面" },
        { folder_id: "F007", folder_name: "TM版図面" },
        { folder_id: "F008", folder_name: "DM版図面" },
        { folder_id: "F009", folder_name: "CM版図面" },
        { folder_id: "F010", folder_name: "BM版図面" },
        { folder_id: "F011", folder_name: "図面表" },
        { folder_id: "F012", folder_name: "購入品リスト" },
      ],
    },
    {
      department_id: "D003",
      department_name: "計測",
      folder: [
        { folder_id: "F013", folder_name: "EK版図面" },
        { folder_id: "F014", folder_name: "TK版図面" },
        { folder_id: "F015", folder_name: "DK版図面" },
        { folder_id: "F016", folder_name: "CK版図面" },
      ],
    },
  ];

  const dept = menuData.find((d) => d.department_id === deptId);
  const folder = dept?.folder?.find((f) => f.folder_id === folderId) || null;

  const folderNameFromRedux = folder?.folder_name || "";

  const getFolderNameLocal = () => {
    return folderNameFromRedux;
  };

  const [formData, setFormData] = useState({
    folder: folderNameFromRedux,
    title: "",
    attributePattern: attributePatternText || "",
  });

  useEffect(() => {
    setFormData((prev) => {
      const nextData = {
        ...prev,
        attributePattern: attributePatternText || "",
      };

      if (prev.attributePattern === nextData.attributePattern) {
        return prev;
      }

      if (onFormDataChange) {
        onFormDataChange(nextData);
      }

      return nextData;
    });
  }, [attributePatternText, onFormDataChange]);

  useEffect(() => {
    const resetData = {
      folder: folderNameFromRedux,
      title: "",
      attributePattern: attributePatternText || "",
    };

    setFormData(resetData);

    if (onFormDataChange) {
      onFormDataChange(resetData);
    }
  }, [resetToken, attributePatternText, onFormDataChange, folderNameFromRedux]);

  // IME構成を追跡するためのState
  const [isComposing, setIsComposing] = useState(false);

  // IME構成開始処理
  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  // IME構成終了処理
  const handleCompositionEnd = (e) => {
    setIsComposing(false);
    // Force validation after composition
    validateAndUpdate(e);
  };

  // 検証および更新を行う関数
  const validateAndUpdate = (e) => {
    const { name, value } = e.target;

    // タイトル項目の最大幅定義
    const fieldMaxWidths = {
      title: 128, // 全角64文字
    };

    const maxWidth = fieldMaxWidths[name];
    if (maxWidth) {
      const currentWidth = getCharacterWidth(value);
      if (currentWidth > maxWidth) {
        // 最大幅に収まるように切り詰める
        let truncatedValue = "";
        let width = 0;
        for (let i = 0; i < value.length; i++) {
          const char = value[i];
          const code = char.charCodeAt(0);
          const charWidth =
            (code >= 0x3040 && code <= 0x309f) || // Hiragana
            (code >= 0x30a0 && code <= 0x30ff) || // Katakana
            (code >= 0x4e00 && code <= 0x9fff) || // CJK Ideographs
            (code >= 0xff00 && code <= 0xffef) || // Full-width ASCII
            (code >= 0x3000 && code <= 0x303f) // Full-width symbols
              ? 2
              : 1;

          if (width + charWidth > maxWidth) break;
          truncatedValue += char;
          width += charWidth;
        }

        const truncatedFormData = {
          ...formData,
          [name]: truncatedValue,
        };
        setFormData(truncatedFormData);

        if (onFormDataChange) {
          onFormDataChange(truncatedFormData);
        }
        return;
      }
    }

    // 通常の更新
    const newFormData = {
      ...formData,
      [name]: value,
    };
    setFormData(newFormData);

    if (onFormDataChange) {
      onFormDataChange(newFormData);
      console.log("CommonForm data:", newFormData);
    }
  };

  // input変更処理
  const handleChange = (e) => {
    const { name, value } = e.target;

    // 常に先に値更新
    const newFormData = {
      ...formData,
      [name]: value,
    };
    setFormData(newFormData);

    // IME構成中は検証スキップ
    if (isComposing) {
      return;
    }

    // IME構成以外の変更時に検証
    validateAndUpdate(e);
  };

  // 発行ボタン処理
  const handleIssue = () => {
    if (onIssue) {
      onIssue();
    }
  };

  return (
    <div className="common-form">
      {/* 1行目: フォルダー */}
      <div className="form-row">
        <label className="form-label">
          フォルダー <span className="required">*</span>
        </label>
        <input
          type="text"
          name="folder"
          value={getFolderNameLocal()}
          className="form-input"
          readOnly
          style={{ backgroundColor: "#fff", maxWidth: "400px" }}
        />
      </div>

      {/* ２行目: タイトル + オートナンバー + 発行 */}
      <div className="form-row">
        <div style={{display: "flex", width: "100%"}}>
          <label className="form-label">
            タイトル <span className="required">*</span>
          </label>
          <div className="form-input-group">
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              onCompositionStart={handleCompositionStart}
              onCompositionEnd={handleCompositionEnd}
              className="form-input"
              maxLength={128}
              //style={{ width: "930px", flex: "none" }}
            />
        </div>
        </div>
        
        <div className="auto-number-group">
          <label className="form-label auto-number-label">
            オートナンバー
          </label>
          <span className="auto-number-value">{autoNumber || ""}</span>
          <button
            type="button"
            className="btn issue-btn-autonumber"
            onClick={handleIssue}
            disabled={loading || isHakkouDisabled}
          >
            発番
          </button>
        </div>

      </div>

      {/* ３行目: 属性パターン */}
      <div className="form-row">
        <label className="form-label">
          属性パターン <span className="required">*</span>
        </label>
        <input
          type="text"
          name="attributePattern"
          value={attributePatternText}
          className="form-input"
          readOnly
          style={{ backgroundColor: "#fff", maxWidth: "400px" }}
        />
      </div>
    </div>
  );
};

export default CommonForm;
